import { render, staticRenderFns } from "./totalPerformance.vue?vue&type=template&id=ecd28d14&scoped=true"
import script from "./totalPerformance.vue?vue&type=script&lang=js"
export * from "./totalPerformance.vue?vue&type=script&lang=js"
import style0 from "./totalPerformance.vue?vue&type=style&index=0&id=ecd28d14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd28d14",
  null
  
)

export default component.exports